import { xqIdxToCoord, xqPieceColor } from '../../../xiangqi-engine.js';
import { XQ_PIECES } from '../../core/catalog.js';

function buildXiangqiSVG() {
  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', 'xq-svg-board');
  svg.setAttribute('viewBox', '0 0 9 10');
  svg.setAttribute('preserveAspectRatio', 'none');
  svg.setAttribute('aria-hidden', 'true');

  const LINE = 'rgba(107,63,32,0.88)';

  function line(x1, y1, x2, y2, width = 0.026) {
    const el = document.createElementNS(NS, 'line');
    el.setAttribute('x1', x1);
    el.setAttribute('y1', y1);
    el.setAttribute('x2', x2);
    el.setAttribute('y2', y2);
    el.setAttribute('stroke', LINE);
    el.setAttribute('stroke-width', width);
    return el;
  }

  function path(d, width = 0.04) {
    const el = document.createElementNS(NS, 'path');
    el.setAttribute('d', d);
    el.setAttribute('stroke', LINE);
    el.setAttribute('stroke-width', width);
    el.setAttribute('fill', 'none');
    return el;
  }

  svg.appendChild(path('M0.5 0.5 L8.5 0.5 L8.5 9.5 L0.5 9.5 Z'));

  for (let r = 1.5; r <= 8.5; r += 1) {
    svg.appendChild(line(0.5, r, 8.5, r));
  }

  for (let file = 1.5; file <= 7.5; file += 1) {
    svg.appendChild(line(file, 0.5, file, 4.5));
    svg.appendChild(line(file, 5.5, file, 9.5));
  }

  svg.appendChild(line(3.5, 0.5, 5.5, 2.5));
  svg.appendChild(line(5.5, 0.5, 3.5, 2.5));
  svg.appendChild(line(3.5, 7.5, 5.5, 9.5));
  svg.appendChild(line(5.5, 7.5, 3.5, 9.5));

  const river = document.createElementNS(NS, 'g');
  river.setAttribute('class', 'xq-river-label');
  const left = document.createElementNS(NS, 'text');
  left.setAttribute('x', '2.0');
  left.setAttribute('y', '5.02');
  left.textContent = '楚  河';
  const right = document.createElementNS(NS, 'text');
  right.setAttribute('x', '5.1');
  right.setAttribute('y', '5.02');
  right.textContent = '漢  界';
  river.append(left, right);
  svg.appendChild(river);

  return svg;
}

export function renderXiangqiBoard(boardEl, board, {
  lastMove,
  selectedIdx,
  legalMovesArr,
  inCheckIdx,
  onClickFn,
  flipped
}) {
  boardEl.innerHTML = '';

  if (!Array.isArray(board) || board.length !== 90) {
    console.error('Invalid Xiangqi board payload', board);
    boardEl.innerHTML = '<div class="board-error">Không thể hiển thị bàn Cờ tướng.</div>';
    return;
  }

  boardEl.appendChild(buildXiangqiSVG());

  const order = [...Array(90).keys()];
  if (flipped) order.reverse();

  for (const idx of order) {
    const r = Math.floor(idx / 9);
    const c = idx % 9;
    const displayRow = flipped ? 9 - r : r;
    const displayCol = flipped ? 8 - c : c;

    const leftPct = ((displayCol + 0.5) / 9) * 100;
    const topPct = ((displayRow + 0.5) / 10) * 100;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'xq-intersection';
    btn.dataset.idx = idx;
    btn.setAttribute('role', 'gridcell');
    btn.setAttribute('aria-label', xqIdxToCoord(idx));
    btn.style.left = `${leftPct}%`;
    btn.style.top = `${topPct}%`;

    if (selectedIdx === idx) btn.classList.add('selected');
    const legalMove = legalMovesArr.find(move => move.to === idx);
    if (legalMove) btn.classList.add(legalMove.captured ? 'capture' : 'legal');

    if (lastMove && (lastMove.from === idx || lastMove.to === idx)) {
      btn.classList.add('last');
      if (lastMove.to === idx) btn.classList.add('last-to');
      if (lastMove.from === idx) btn.classList.add('last-from');
    }

    if (lastMove?.captured && lastMove.to === idx) btn.classList.add('capture-event');
    if (idx === inCheckIdx) btn.classList.add('in-check');

    const piece = board[idx];
    if (piece) {
      const span = document.createElement('span');
      span.className = `xq-piece ${xqPieceColor(piece) === 'w' ? 'red' : 'black'}`;
      span.textContent = XQ_PIECES[piece] || '';
      btn.appendChild(span);
    }

    btn.addEventListener('click', () => onClickFn(idx));
    boardEl.appendChild(btn);
  }
}
